export const bannerText = {
  title:
    "We transform AI and technology into competitive advantages for your business",
  subTitle:
    "We integrate innovation, methodology, and talent to enable seamless adoption and scalable implementation across your teams.",
  buttonConsult: "Get Free Consultation",
  ourServices: "Our solutions",
  certificatePart1: "Our processes are accredited by ISO 9001:2015",
  certificatePart2:
    "certification in quality practices for the development of software products.",
};

export const trusted = {
  whoTrustUs: "Who trust us",
};
export const menuServices = {
  title: "Solutions",
  subtitle1: "Get your business up and running with",
  subtitle2: "our solutions",
  softPart1: "Software",
  softPart2: "Engineering",
  button: "Learn More",
  sre: "Cloud Engineering & DevOps Practice",
  staffPart1: "Staff",
  staffPart2: "Augmentation",
  staffPart1MenuHeader: "Staff augmentation",
  digitalProductSubtitle: "Turn AI and data into concrete business use cases",
  digitalProductPart1: "AI & Data",
  digitalProductPart2: "",
  cloudAndDevOpsSubtitle: "Reduce your exposure so you gain day-to-day operational control",
  cloudAndDevOpsPart1: "Security",
  cloudAndDevOpsPart2: "",
  dataScienceSubtitle: "Accelerate development across full-code or low-code teams with AI agents",
  dataSciencePart1: "AI-Augmented Software",
  dataSciencePart2: "Engineering",
  aiEngineeringSubtitle: "Optimize your infrastructure with secure cloud solutions and reliable IT management",
  aiEngineeringPart1: "Managed Cloud &",
  aiEngineeringPart2: "DevOps Services",
  buttonSend: "Start the conversation",
};
export const aboutUsWhatMovesUs = {
  aboutMenuHeader: "About",
  titleLinkMenu: "About",
  title: "About us",
  subTitle: "What moves us",
  description1: `From engineering plans to production-ready outcomes.
  
  - We add engineering capacity that turns priorities into working software and measurable progress.
  - We combine software, cloud, data, and AI expertise with an understanding of business outcomes.
  - We integrate with your teams, standards, and workflows to support sustainable delivery.
  
  Because engineering capacity creates more value when people, processes, and technology move forward together.`,
  whatWeAre: "What we are",
};
export const valueProposal = {
  title: "Why Possumus",
  description1: `Possumus combines nearshore collaboration, Microsoft expertise, AI-augmented engineering practices, and flexible staffing models. You stay focused on product and business priorities while our professionals expand the capacity to execute them.
  
  Share the initiative, capability gap, or delivery constraint. We will help define whether you need a specialist, an embedded team, or a broader engineering engagement.`,
  description2:
    "Share the initiative, capability gap, or delivery constraint. We will help define whether you need a specialist, an embedded team, or a broader engineering engagement.",
  button: "Build your nearshore team",
};

export const organizationalPolicy = {
  title: "Organizational policy",
};
export const careers = {
  title: "Careers",
  work: "Work with us!",
  apply: "Apply now",
};
export const awards = {
  title: "Awards and recognitions",
  description:
    "Independent recognitions that support our experience in software development, financial services, and staff augmentation.",
  button: "What our customers say",
};
export const contact = {
  title: "Contact",
  contactLink: "Contact us",
};
export const downloadFree = {
  title: "Download our deck and let’s talk",
};
export const msSeparator = {
  title: `We are a leading Microsoft
  partner across the Americas`,
};

export const page404 = {
  title: "Something gone missing...",
  paragrahp:
    "Sorry, the content you are looking for does not exist. Either it has been removed, or you mistyped the link.",
  button: "Go Home",
};
